jQuery('.js-qty-button').on('click', (e) => {
  e.preventDefault()

  const target = jQuery(e.target).attr('data-target')
  const $target = jQuery(`#${target}`)
  const increase = jQuery(e.target).data('increase')
  const value = $target.val()
  const maxValue = parseInt($target.attr('max'))

  const newValue = (parseInt(value) + parseInt(increase))

  $target.val(newValue < 1 ? 1 : newValue > maxValue ? maxValue : newValue)

  jQuery( '.woocommerce-cart-form :input[name="update_cart"]' ).prop( 'disabled', false ).attr( 'aria-disabled', false )
})
